import { isEmailFormatValid, isFreeEmailDomain, normalizeEmail } from "../utils/email";

import { getVisitorId } from "./visitorId";

const BASE = "/api/form-messages";

export async function submitFormMessage(payload = {}) {
  const normalizedEmail = normalizeEmail(payload?.email);
  if (!normalizedEmail || !isEmailFormatValid(normalizedEmail) || isFreeEmailDomain(normalizedEmail)) {
    const err = new Error("Invalid email");
    err.validation = { email: "Invalid email" };
    throw err;
  }
  const currentUrl = typeof window !== "undefined" ? window.location.href : null;
  const referrer = typeof document !== "undefined" ? document.referrer || null : null;
  const visitorId = getVisitorId();
  const baseMetadata = payload?.metadata && typeof payload.metadata === "object" ? payload.metadata : {};
  const mergedMetadata = { visitor_id: visitorId, ...baseMetadata };
  const body = { ...payload, email: normalizedEmail, currentUrl, referrer, metadata: mergedMetadata };
  const res = await fetch(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error(data?.error || "Request failed");
    if (data?.errors) err.validation = data.errors;
    throw err;
  }
  return data;
}

export async function listFormMessages({ limit = 100, offset = 0 } = {}) {
  const res = await fetch(`${BASE}?limit=${limit}&offset=${offset}`);
  if (!res.ok) throw new Error(`List failed (${res.status})`);
  return res.json();
}
